import {IBoosterCycle} from 'core/api/prescription'
import {BoosterIds} from './identifiers'

const SHOOTING_STARS_DEMO_RBR: IBoosterCycle = {
  name: 'SHOOTING_STARS_DEMO_RBR',
  items: [{
    ...BoosterIds.SHOOTING_STARS_DEMO_RED_ID,
    leadTime: 5 * 1000,
  }, {
    ...BoosterIds.SHOOTING_STARS_DEMO_BLUE_ID,
    leadTime: 10 * 1000,
  }, {
    ...BoosterIds.SHOOTING_STARS_DEMO_RED_ID,
    leadTime: 10 * 1000,
  }],
}

const BG_FLASHES_DEMO_RGR: IBoosterCycle = {
  name: 'BG_FLASHES_DEMO_RGR',
  items: [{
    ...BoosterIds.BG_FLASHES_DEMO_RRR_ID,
    leadTime: 5 * 1000,
  }, {
    ...BoosterIds.BG_FLASHES_DEMO_GGG_ID,
    leadTime: 10 * 1000,
  }, {
    ...BoosterIds.BG_FLASHES_DEMO_RRR_ID,
    leadTime: 10 * 1000,
  }],
}

const TIMED_TARGET_DEMO: IBoosterCycle = {
  name: 'TIMED_TARGET_DEMO',
  items: [{
    ...BoosterIds.TIMED_TARGET_DEMO_ID,
    leadTime: 5 * 1000,
  }],
}

const MEDLEY_DEMO: IBoosterCycle = {
  name: 'MEDLEY_DEMO',
  items: [{
    ...BoosterIds.SHOOTING_STARS_DEMO_RED_ID,
    leadTime: 5 * 1000,
  }, {
    ...BoosterIds.BG_FLASHES_DEMO_RRR_ID,
    leadTime: 5 * 1000,
  }, {
    ...BoosterIds.TIMED_TARGET_DEMO_ID,
    leadTime: 5 * 1000,
  }],
}

const CAM1C__1: IBoosterCycle = {
  name: 'CAM1C__1',
  items: [
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:  5 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime:  5 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime: 10 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:  5 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:  7 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime:  5 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:  7 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime:  7 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime: 10 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime:  5 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime: 10 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime:  7 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime:  7 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:  5 * 1000 },
    { ...BoosterIds.BG_FLASHES__20170908_ID,     leadTime:  7 * 1000 },
  ],
}

const CAM1D__1: IBoosterCycle = {
  name: 'CAM1D__1',
  items: [
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:      5 * 1000 },
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime:      5 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime:     10 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:      5 * 1000 },
    // Group 1
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime: 2 * 60 * 1000 },
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime:      5 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:      7 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime:      7 * 1000 },
    // Group 2
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime: 2 * 60 * 1000 },
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime:      5 * 1000 },
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime:     10 * 1000 },
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime:      7 * 1000 },
    { ...BoosterIds.TIMED_TARGET__20170908_ID,   leadTime:      7 * 1000 },
    // Group 3 (or 0)
    { ...BoosterIds.SHOOTING_STARS__20170908_ID, leadTime: 2 * 60 * 1000 },
    { ...BoosterIds.BG_FLASHES__20171003_ID,     leadTime:      7 * 1000 },
  ],
}

const NO_BOOSTERS: IBoosterCycle = {
  name: 'NO_BOOSTERS',
  items: [],
}

/**
 * All booster cycles.
 * All cycles MUST be exported through this object to ensure tests are run.
 */
export const BoosterCycles = {
  // Demos
  SHOOTING_STARS_DEMO_RBR,
  BG_FLASHES_DEMO_RGR,
  TIMED_TARGET_DEMO,
  MEDLEY_DEMO,
  // General
  NO_BOOSTERS,
  // CAM1C
  CAM1C__1,
  // CAM1D
  CAM1D__1,
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/booster/cycle.ts